import {useQuery} from "react-query";
import {Client} from "../../autogenerate/api.generated.clients";

export function useMembersOnlyUsersForOrganization(organizationId: string) {
    return useQuery('mo-users-for-organization', () => new Client().organization_GetMembersOnlyUsersForOrganization(organizationId));
}